import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  EventEmitter,
  Input,
  Output,
  OnInit,
  inject,
  OnDestroy,
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

import { Subject, takeUntil } from 'rxjs';

import { AppSharedModule } from 'app/app-shared.module';
import { ExtractFormControl } from 'app/utils/validator.utils';

interface NotesForm {
  notes: FormControl<string>;
}

type NotesFormValue = ExtractFormControl<NotesForm>;

@Component({
  selector: 'app-notes-editor',
  imports: [AppSharedModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './notes-editor.component.html',
  styleUrls: ['./notes-editor.component.scss'],
})
export class NotesEditorComponent implements OnInit, OnDestroy {
  @Input() notes: string;

  @Output() close = new EventEmitter<string | null>();

  form: FormGroup<NotesForm>;
  private originalFormValue: NotesFormValue;

  hasChanges = false;

  private readonly _formBuilder = inject(FormBuilder);

  private readonly _destroy$ = new Subject<void>();

  ngOnInit(): void {
    this.buildForm();
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  onSave(): void {
    const notes = this.form.getRawValue().notes.trim();

    this.close.emit(notes);
  }

  onCancel(): void {
    this.close.emit(null);
  }

  private buildForm(): void {
    this.form = this._formBuilder.group<NotesForm>({
      notes: new FormControl(this.notes),
    });

    this.form.valueChanges
      .pipe(takeUntil(this._destroy$))
      .subscribe(
        () =>
          (this.hasChanges = this.originalFormValue.notes !== this.form.getRawValue().notes.trim())
      );

    this.originalFormValue = this.form.getRawValue();
  }
}
